import * as angular from "angular";
import { NOTIFICATION_SERVICE, NotificationService } from "./../core/notification.service";
import { BEngLogsService, BENG_LOGS_SERVICE } from "./beng-logs.service";
import { User } from "oidc-client";
import { some, find } from "lodash";
import * as fileSaver from "file-saver";
import "./beng-logs.less";
import { IBEngLogMode } from "../../typings/board/Admin";
import { BENGLOG_PASSWORD_DIALOG_SERVICE, BengLogPasswordDialogService } from "./beng-log-password-dialog.controller";

export const BENGLOG_DIALOG_SERVICE = "bengLogDialogService";

export class BengLogDialogService {

    static $inject = ["$q", "$timeout", "$mdDialog"];
    constructor(private $q: ng.IQService, private $timeout: ng.ITimeoutService, private $mdDialog: ng.material.IDialogService) { }

    public showConfigDialog(boardWebUser: User, configurations: IBEngLogMode[]): ng.IPromise<any> {

        if (angular.isUndefined(boardWebUser) || angular.isUndefined(configurations)) { return this.$q.reject(); }

        return this.$mdDialog.show({
            controller: BengLogConfigDialogController,
            controllerAs: "$ctrl",
            template: require("./beng-log-config-dialog.html"),
            focusOnOpen: true,
            clickOutsideToClose: false,
            escapeToClose: true,
            bindToController: true,
            fullscreen: true,
            locals: { "boardWebUser": boardWebUser, "configurations": configurations }

        });

    }
}

export class BengLogConfigDialogController {

    private boardWebUser: User;
    private configurations: IBEngLogMode[];

    private applyDisabled: boolean;
    private logsAreEncrypted: boolean;

    private readonly enableLogEncryptionKey = "Enable Log Encryption";

    static $inject = ["$q", "$timeout", "$mdDialog", BENG_LOGS_SERVICE, NOTIFICATION_SERVICE, BENGLOG_PASSWORD_DIALOG_SERVICE];
    constructor(
        private $q: ng.IQService,
        private $timeout: ng.ITimeoutService,
        private $mdDialog: ng.material.IDialogService,
        private bengLogsService: BEngLogsService,
        private notification: NotificationService,
        private passwordDialogService: BengLogPasswordDialogService
    ) {
        this.logsAreEncrypted = some(this.configurations, c => c.key === this.enableLogEncryptionKey && c.enabled);
        this.applyDisabled = true;
    }

    private configChanged(mode: IBEngLogMode) {

        this.applyDisabled = false;

        if (mode.key !== this.enableLogEncryptionKey) {
            return;
        }

        if (mode.enabled) {

            this.passwordDialogService.showSetPasswordDialog(this.boardWebUser).then((args) => {
                this.bengLogsService.enableEncryption(args).then(
                    () => {
                        this.setEncryptionMode(true);
                    },
                    (response) => {
                        this.encryptionFails(response.data.message);
                        this.setEncryptionMode(false);
                    }
                );
            }, (message) => {
                this.encryptionFails(message);
                this.setEncryptionMode(false);
            });

        } else {

            this.passwordDialogService.showRemovePasswordDialog(this.boardWebUser).then((args) => {
                this.bengLogsService.disableEncryption(args).then(
                    () => {
                        this.setEncryptionMode(false);
                    },
                    (response) => {
                        this.encryptionFails(response.data.message);
                        this.setEncryptionMode(true);
                    }
                );
            }, (message) => {
                this.encryptionFails(message);
                this.setEncryptionMode(true);
            });

        }

    }

    private changeEncryptionPassword() {
        this.passwordDialogService.showChangePasswordDialog(this.boardWebUser).then((args) => {
            this.bengLogsService.updateEncryptionPassword(args).then(
                () => {
                    this.notification.show("Password updated!");
                },
                (response) => {
                    this.encryptionFails(response.data.message);
                }
            );
        }, (message) => this.encryptionFails(message));
    }

    private encryptionFails(errorMessage: string) {
        if (errorMessage.length > 0) {
            this.notification.error(errorMessage);
        }
    }

    private setEncryptionMode(enabled: boolean) {
        const mode = find(this.configurations, c => c.key === this.enableLogEncryptionKey);
        if (mode) {
            mode.enabled = enabled;
        }
        this.logsAreEncrypted = enabled;
    }

    private downloadDecrypter() {
        this.bengLogsService.downloadDecrypter().then(binary => {
            fileSaver.saveAs(binary, "Decrypter.exe");
        });
    }

    private applyChanges() {
        this.bengLogsService.setConfigurations(this.configurations).then(
            () => {
                this.notification.show("Changes has been saved!");
                this.$mdDialog.hide();
            },
            (response) => {
                this.notification.error(response.data.message);
            }
        );
    }

    private cancel() {
        this.$mdDialog.cancel();
    }

}


// WEBPACK FOOTER //
// ./app/beng-logs/beng-log-config-dialog.controller.ts